import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PayoutPreferenceBecomeCreator from '../../common/payment-preference.js';
import WelcomeMessageSubscribers from '../../common/welcome-message.js';
import BasicProfile from '../../common/basic-profile-become-creator.js';
import ProfileCover from '../../common/profile-cover.js';
import SubscriptionPrice from '../../common/subscription-price.js';
import PageChecklist from '../../common/page-checklist.js';
import PRainbowToast from '../../common/PRainbowToast';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Spinner from 'react-bootstrap/Spinner';
import { PAUSE_STATUS, ROLES } from '../../utils/constants';
import AlertConfirmModal from '../../common/AlertConfirmModal';
import useDidMountEffect from '../../utils/useDidMountEffect';
import MetaTags from 'react-meta-tags';
import { setAlert, setUser as setUserR } from '../../../redux/actions.js';

import './become-creator.css';
import { useDispatch } from 'react-redux';
import useRedirectIfNoData from '../../utils/useRedirectIfNoData.js';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from '../../utils/constants';
import { useMediaQuery } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2.js';
import DefaultPUWidget from '../../Widgets/PU/Default/index.js';
import DefaultWidget from '../../Widgets/SU/Default/index.js';
import PageHeader from '../../common/PageHeader/index.js';

const BecomeCreator = () => {
    useRedirectIfNoData('/login');

    const isMobile = useMediaQuery('(max-width: 899px)');

    const [user, setUser] = useState({});
    const [showToast2, setShowToast2] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [hasConfirm, setHasConfirm] = useState(false);
    const [pauseState, setPauseState] = useState();
    const [countTrigger, setCountTrigger] = useState(0);
    const userId = localStorage.getItem('loggedin_user');

    const dispatch = useDispatch();

    const getUserInformation = async () => {
        setIsBusy(true);
        await axios.get(`/api/users/${userId}`)
            .then((response) => {
                setUser(response.data);
                setPauseState(response.data.creator.pause_status);
                localStorage.setItem('user', JSON.stringify(response.data));
                dispatch(setUserR(response.data));
            })
            .catch((error) => {
                console.log({ error });
            }).finally(() => {
                setIsBusy(false);
            });
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getUserInformation();
    }, []);

    const handleCopyReferral = (e) => {
        e.preventDefault();
        const link = `${process.env.MIX_APP_URL}/?ref=${user.id}`;
        copy(`${link}`, {
            debug: false,
            message: 'Click to copy link',
        });
    };

    const doPauseAction = async () => {
        setIsBusy(true);
        await axios.patch(`/api/creators`, {
            pause_status: pauseState
        })
            .then(response => {
                getUserInformation();
                let message = 'Your account has now been Paused';

                if (pauseState == 0) {
                    message = 'Your account status is now Resumed';
                }

                dispatch(setAlert({
                    show: true,
                    type: 'success',
                    body: message
                }));
            })
            .catch(error => {
                console.error({ error });
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Unable to pause account'
                }));
            });
        // isBust state us updated by get user information
    };

    const handlePause = (e, pauseStatus = PAUSE_STATUS.PAUSED) => {
        e.preventDefault();
        if (pauseStatus == PAUSE_STATUS.UNPAUSED) {
            setPauseState(PAUSE_STATUS.UNPAUSED);
            setCountTrigger(countTrigger => countTrigger + 1);
        } else {
            // setAlertText('Are you sure to delete your account?');
            setShowAlert(true);
            setHasConfirm(true);
        }
    };

    useDidMountEffect(() => {
        doPauseAction();
    }, [countTrigger]);


    return (
        <div className="container become-creator-main-container pt-4 mb-4">
            <MetaTags>
                <title>Become a Creator &#8211; Best way to make money as an influencer for your exclusive content</title>
                <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
            </MetaTags>

            <Grid2
                container
                spacing={!isMobile ? 2 : 0}
            >
                <Grid2 item md={8}>
                    <PageHeader title={user.role == ROLES.PU ? 'Creator Settings' : 'Become a Creator'} />
                    {user.creator && user.creator.pause_status == PAUSE_STATUS.PAUSED ? <div className="my-2"><strong>Account has been paused</strong></div> : ''}
                    <div className="your-referral-link text-center">
                        <div className="advanced-settings text-center my-2 pb-3">
                            {
                                user.role == ROLES.PU && <Link to="/creator-advanced-settings" className="btn theme-btn theme-btn-bordered">Creator Advanced Settings</Link>
                            }
                        </div>
                        <h5 className="text-uppercase mb-0"><b>Your Profile Link</b></h5>
                        <p style={{ marginBottom: '2px' }}>
                            {process.env.MIX_APP_URL}/{user.login}
                        </p>
                        <PRainbowToast
                            show={showToast2}
                            setShow={setShowToast2}
                            message={`Copied Referral Link ${process.env.MIX_APP_URL}/${user.login}`}
                            customStyle={{ top: 75, left: '40%' }}
                        />

                        <CopyToClipboard
                            text={`${process.env.MIX_APP_URL}/${user.login}`}
                            onCopy={() => setShowToast2(true)}
                        >
                            <a className="btn theme-btn theme-btn-bordered">Copy Link</a>
                        </CopyToClipboard>
                    </div>

                    <div className="payout-pref-container mt-4">
                        <PageChecklist />
                    </div>

                    <div className="payout-pref-container mb-4">
                        <SubscriptionPrice getUserInformation={getUserInformation} />
                    </div>

                    <div className="payout-pref-container mb-4">
                        <ProfileCover user={user} getUserInformation={getUserInformation} />
                    </div>

                    <div id="grecaptcha-provider" className="payout-pref-container mb-4">
                        <GoogleReCaptchaProvider
                            language="en"
                            useRecaptchaNet="true"
                            reCaptchaKey={RECAPTCHA_SITE_KEY}
                            scriptProps={{
                                defer: true, // optional, default to false
                                appendTo: 'body', // optional, default to "head", can be "head" or "body",
                            }}
                        >
                            <BasicProfile user={user} />
                        </GoogleReCaptchaProvider>
                    </div>

                    <div className="payout-pref-container welcome-message-container mb-4">
                        <WelcomeMessageSubscribers user={user} />
                    </div>

                    <div className="payout-pref-container mb-4">
                        <PayoutPreferenceBecomeCreator user={user} step="6" />
                    </div>

                    {user.creator && <div className="payout-pref-container mb-4">
                        <div className="panel panel-default pause-panel">
                            <div className="panel-body clearfix">
                                <h4>Pause Account</h4>
                                <div className="my-1">
                                    If you want to take a break and stop charging your subscribers their monthly fee, you can pause the collection of subscription payments until you’re ready to start up again. {!isBusy && user.creator.pause_status == PAUSE_STATUS.UNPAUSED && <b><a href="#" className="pause_account_click" onClick={(e) => handlePause(e)}>Click here to pause</a></b>}
                                    {!isBusy && user.creator.pause_status == PAUSE_STATUS.PAUSED && <b><a href="#" className="pause_account_click" onClick={(e) => handlePause(e, PAUSE_STATUS.UNPAUSED)}>Click here to resume</a></b>}
                                    {isBusy && <div style={{ display: 'inline' }}><Spinner variant="primary" size="sm" animation="border" /></div>}
                                </div>
                                <p>When your account is paused, the following occurs</p>
                                <ul className="lsit-unstyled fa-ul">
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />People cannot subscribe to you</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />Current subscribers will not be charged any subscription during the paused break period</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />You can still post content and current subscribers will have access to your posts.</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />You and your subscribers can interact via commend and direct messages</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />You can still send PPVs and receive Tips</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />Existing subscribers will see your account is Paused and receive notification</li>
                                    <li><FontAwesomeIcon icon={['fas', 'circle']} />If you are inactive for more than a month your account will automatically be paused. This is for your own protection to prevent refund requests and chargebacks from your subscribers who will get upset about getting charged when you’re not active i.e. posting or messaging. When you’re ready to start again, simply click to unpause.</li>
                                </ul>
                                <h4>Why Pause My Account</h4>
                                <p>If you're inactive and your subscribers are still getting charged, you may find that they may get upset and start requesting refunds. Some may even claim chargebacks with their bank to retireve the funds, as per our terms, the bank deducts a $25 fee for each chargeback. We have no control over this fee, so it is in your interest to communicate your level of activity to your subscribers and to pause your account when you know you will be inactive.</p>
                            </div>
                        </div>
                    </div>}
                </Grid2>

                {
                    !isMobile
                        ? <Grid2 item className='pu-homepage__right' md={4}>
                            {
                                user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                            }
                            {
                                user && user.role == ROLES.SU ? <DefaultWidget /> : null
                            }
                        </Grid2>
                        : null
                }
            </Grid2>


            {showAlert && <AlertConfirmModal modalTitle="Confirm" modalBody="Are you sure you want to pause your account?" show={showAlert} setShow={setShowAlert} isConfirm={hasConfirm} useFunction={() => { setPauseState(pauseState => !pauseState); setCountTrigger(countTrigger => countTrigger + 1); }} />}
        </div>
    );
};

export default BecomeCreator;
